import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'module',
    serviceName: 'grapghql',
    query: gql`
      query module($ids: [String]) {
        module(ids: $ids) {
          data {
            type {
              id
            }
            shop {
              id
            }
            pages
            title
            text
            url
            start_time
            end_time
            is_active
            btn_text
            has_timer
            use_for_child
          }
        }
      }
    `,
  },
  update: {
    name: 'updateModule',
    serviceName: 'shopadmin',
    query: gql`
      mutation updateModule(
        $ids: [String]!
        $type_id: String
        $shop_id: String
        $pages: String
        $title: String
        $text: String
        $url: String
        $start_time: String
        $end_time: String
        $is_active: Int
        $btn_text: String
        $has_timer: Int
        $use_for_child: Int
      ) {
        updateModule(
          ids: $ids
          type_id: $type_id
          shop_id: $shop_id
          pages: $pages
          title: $title
          text: $text
          url: $url
          start_time: $start_time
          end_time: $end_time
          is_active: $is_active
          btn_text: $btn_text
          has_timer: $has_timer
          use_for_child: $use_for_child
        ) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
